import { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Record, Rollcall,Help, Vacation  , Delay, Absence, Overtime , Profile} from "../../pages";
import { ProtectedRoute } from "./ProtectedRoute";
import { ContextNav } from "../../context/ContextNav";


export const Container = (props: any) => {
    const location = useLocation();
    const CtxNav = useContext(ContextNav)


    return (
        <div className='w-full flex flex-col'>
            {props.children}
            <Routes>
                <Route path="record" element={<ProtectedRoute><Record /></ProtectedRoute>} />
                <Route path="rollcall" element={<ProtectedRoute><Rollcall /></ProtectedRoute>} />
                <Route path="vacation" element={<ProtectedRoute><Vacation /></ProtectedRoute>} />
                <Route path="delay" element={<ProtectedRoute><Delay /></ProtectedRoute>} />
                <Route path="overtime" element={<ProtectedRoute><Overtime /></ProtectedRoute>} />
                <Route path="absence" element={<ProtectedRoute><Absence /></ProtectedRoute>} />
                <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
            </Routes>
        </div>
    );
}